<template>
    <div class="com-item aboutImg-module" :class="{active: isactive==true}" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: W.bgColor || 'transparent',
                    color: W.textColor || '#333'
                }"
            >
                <div class="aboutImg-module__inner">
                    <div class="aboutImg-module__left">
                        <p class="aboutImg-module__en">{{ W.enTitle }}</p>
                        <div class="aboutImg-module__cn" v-html="W.cnTitleHtml"></div>
                        <div class="aboutImg-module__desc" v-html="W.describeHtml"></div>
                        <a
                            v-if="W.btnText"
                            class="aboutImg-module__btn"
                            :href="W.btnLink && W.btnLink.linkUrl ? W.btnLink.linkUrl : 'javascript:void(0)'"
                            target="_self"
                            @click.stop="onBtnClick($event)"
                        >
                            <span>{{ W.btnText }}</span>
                            <span class="arrow-icon"></span>
                        </a>
                    </div>
                    <div class="aboutImg-module__right" v-if="W.rightImg">
                        <div class="aboutImg-module__imgWrap">
                            <div
                                class="aboutImg-module__img"
                                :style="{ backgroundImage: imgMaskStyle }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "aboutImg-module",
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'aboutImg',
                    Title: '关于AES',
                    MID: 31,
                    ModuleName: 'aboutImgModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        },
        imgMaskStyle: function() {
            const url = (this.modata.WContent && this.modata.WContent.rightImg) || ''
            const escaped = String(url).replace(/"/g, '\\"')
            return 'url("' + escaped + '")'
        }
    },
    data() { return {} },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
    },
    methods: {
        onBtnClick(e) {
            const W = this.modata.WContent || {}
            if (!W.btnLink || !W.btnLink.linkUrl) {
                e.preventDefault()
                return
            }
            e.preventDefault()
            this.pageNavigate(W.btnLink.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.aboutImg-module {
    .van-sticky {
        min-height: 50px;
    }

    .aboutImg-module__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 92%;
        max-width: 1600px;
        margin: 0 auto;
    }

    .aboutImg-module__left {
        flex: 0 0 45%;
        max-width: 620px;
        padding-right: 5%;
        box-sizing: border-box;
    }

    .aboutImg-module__right {
        flex: 1;
        min-width: 0;
    }

    .aboutImg-module__en {
        font-size: 18px;
        color: #737373;
        line-height: 1.4;
        margin: 0 0 12px;
    }

    .aboutImg-module__cn {
        font-size: 28px;
        font-weight: bold;
        line-height: 1.3;
        margin: 0 0 24px;
        color: #333;

        ::v-deep p { margin: 0 0 8px; }
    }

    .aboutImg-module__desc {
        font-size: 16px;
        line-height: 1.7;
        color: #737373;
        margin: 0 0 32px;
        max-width: 600px;

        ::v-deep p { margin: 0 0 8px; }
    }

    .aboutImg-module__btn {
        display: inline-block;
        position: relative;
        overflow: hidden;
        text-align: center;
        box-sizing: border-box;
        padding: 14px 36px;
        background: linear-gradient(to right, #f86f64, #e60012);
        border: none;
        border-radius: 10px;
        color: #fff;
        font-size: 15px;
        text-decoration: none;
        box-shadow: 0 7rpx 46rpx 0 rgba(187, 17, 72, 0.48), 0 3rpx 6rpx 0 rgba(255, 255, 255, 0.64);
        transition: all 0.3s;


        span {
            display: inline-block;
            position: relative;
            z-index: 1;
        }
        .arrow-icon{
            width: 8px;
            height: 8px;
            border-top: solid 1px #fff;
            border-right: solid 1px #fff;
            transform: rotate(45deg);
            margin:0 0 1px 6px;
            
        }

        &:hover {
            opacity: 0.95;
        }
    }

    .aboutImg-module__imgWrap {
        width: 100%;
        height: 460px;
        overflow: hidden;
    }

    .aboutImg-module__img {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #f2f2f2;
        -webkit-mask-image: url('data:image/svg+xml;utf8,<svg t="1783867672814" class="icon" viewBox="0 0 2592 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6858" width="64" height="64"><path d="M499.648 60.16A128 128 0 0 1 608.192 0H2457.28a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128.192C27.648 1024-33.6 913.408 19.648 828.16l480-768z" fill="%23000"></path></svg>');
        mask-image: url('data:image/svg+xml;utf8,<svg t="1783867672814" class="icon" viewBox="0 0 2592 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6858" width="64" height="64"><path d="M499.648 60.16A128 128 0 0 1 608.192 0H2457.28a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128.192C27.648 1024-33.6 913.408 19.648 828.16l480-768z" fill="%23000"></path></svg>');
        -webkit-mask-size: 100% 100%;
        mask-size: 100% 100%;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;


    }
}

// <svg t="1783867672814" class="icon" viewBox="0 0 2592 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6858" width="64" height="64"><path d="M499.648 60.16A128 128 0 0 1 608.192 0H2457.28a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H128.192C27.648 1024-33.6 913.408 19.648 828.16l480-768z" fill="%23000"></path></svg>
// <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'><path d='M 15,0 L 98,0 A 2 2 0 0 1 100,2 L 100,98 L 85,100 L 2,100 A 2 2 0 0 1 0,98 L 0,2 Z' fill='%23000'/></svg>
@media screen and (max-width: 768px) {
    .aboutImg-module {
        .aboutImg-module__inner {
            flex-direction: column-reverse;
                    margin-bottom: 2%;
        }
        .aboutImg-module__left {
            flex: 0 0 100%;
            max-width: 100%;
            padding-right: 0;
            margin-bottom: 0;
        }
        .aboutImg-module__right {
            flex: 0 0 100%;
            width: 100%;
        }
        .aboutImg-module__imgWrap {
            height: 240px;
        }
        .aboutImg-module__cn {
            font-size: 28px;
        }
        .aboutImg-module__cn{
            margin-bottom: 0;
        }
        .aboutImg-module__desc{
            margin-bottom: 4px;
        }
    }
}
</style>
